import { render, staticRenderFns } from "./RiskLevelReviewPopup.vue?vue&type=template&id=1e2545fb"
import script from "./RiskLevelReviewPopup.vue?vue&type=script&lang=js"
export * from "./RiskLevelReviewPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports